export default __webpack_public_path__ + "static/floor3-slide-3-35501b5ff38e150d4f657a1fd302d784.jpg";